module.exports = __webpack_public_path__ + "img/empty.d5ae8317.png";